"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var formatsValidator = function formatsValidator(value, options) {
    return value && options.rules.map(function (rule) {
        return !!value.match(rule.pattern) !== rule.match ? rule.message : undefined;
    }).filter(function (validation) {
        return validation !== undefined;
    });
};

var _default = formatsValidator;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(formatsValidator, "formatsValidator", "src/validators/formatsValidator.js");

    __REACT_HOT_LOADER__.register(_default, "default", "src/validators/formatsValidator.js");
}();

;


// WEBPACK FOOTER //
// /Users/david/Source/react-formality/lib/validators/formatsValidator.js